























import { Pracovnik } from '@/modules/administrace/pracovnik';

import Base from './Base.vue';
import { editMutations } from '../store/types';

export default Base.extend({
	name: 'TiskPracovnichPrukazek',
	components: {
		BaseFilterSestav: Base,
		PracovnikSelect: Pracovnik.components.Select,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				pracovnik: `${this.storeUri}/${editMutations.PRACOVNIK_SELECT_MAPPER}`,
			};
		},
	},
});
